import {AllianceColor, BiobuzzScoreDetail, BiobuzzScoringElement} from "ftc-common/javaTypes";
import {classes as commonClasses} from "ftc-common/typescript-generator-info.json"

export type ScoreType = BiobuzzScoreDetail & {
    swarmRPProgress: [number, number],
    pollinator1RPProgress: [number, number],
    pollinator2RPProgress: [number, number],
}
export type ScoreTypeSetValue = <K extends keyof ScoreType>(key: K, value: ScoreType[K]) => void

// TODO make these configurable maybe (or just document the calculator is always for qualifier-level events?)
const SWARM_RP_THRESHOLD = 16;
const POLLINATOR_1_RP_THRESHOLD = 4;
const POLLINATOR_2_RP_THRESHOLD = 7;

export const defaultScore : ScoreType = {
    clazz: commonClasses.find((cc) => cc.typeName === 'BiobuzzScoreDetail')!.javaClass,
    adjust: 0,
    autoHiveTips: 0,
    autoRobot1Leave: false,
    autoRobot2Leave: false,
    autoRobot1Park: false,
    autoRobot2Park: false,
    teleopHiveTips: 0,
    teleopHivePollenNectar: 0,
    redAllianceFlower: [],
    scoringFlower: [],
    blueAllianceFlower: [],
    audienceFlower: [],
    teleopGardenPollenNectar: 0,
    teleopRobot1Park: false,
    teleopRobot2Park: false,
    minorFouls: 0,
    majorFouls: 0,
    autoLeavePoints: 0,
    autoParkPoints: 0,
    autoHivePoints: 0,
    teleopHivePoints: 0,
    teleopFlowerPoints: 0,
    teleopGardenPoints: 0,
    teleopParkPoints: 0,
    autoPoints: 0,
    teleopPoints: 0,
    foulPointsCommitted: 0,
    preFoulTotal: 0,
    violations: [],
    ownMajorFouls: 0,
    ownMinorFouls: 0,
    otherMajorFouls: 0,
    otherMinorFouls: 0,
    hrMajorFouls: 0,
    hrMinorFouls: 0,
    flowersOwned: 0,
    flowersPlugged: 0,
    swarmRP: false,
    pollinator1RP: false,
    pollinator2RP: false,
    swarmRPProgress: [0, SWARM_RP_THRESHOLD],
    pollinator1RPProgress: [0, POLLINATOR_1_RP_THRESHOLD],
    pollinator2RPProgress: [0, POLLINATOR_2_RP_THRESHOLD],
}

const AUTO_LEAVE_VALUE = 3;
const AUTO_PARK_VALUE = 5;
const AUTO_HIVE_TIP_VALUE = 20;

const TELEOP_HIVE_TIP_VALUE = 20;
const TELEOP_HIVE_POLLEN_NECTAR_VALUE = 2;
const TELEOP_BOTTOM_NECTAR_BONUS_VALUE = 5;
const TELEOP_FLOWER_POLLEN_NECTAR_VALUE = 2;
const TELEOP_GARDEN_POLLEN_NECTAR_VALUE = 1;
const TELEOP_PARK_VALUE = 5;

const MAJOR_FOUL_VALUE = 20;
const MINOR_FOUL_VALUE = 5;

export function calculateScoreBreakdown(score: ScoreType, _random: number, alliance: AllianceColor) {
    score.autoLeavePoints = (score.autoRobot1Leave ? AUTO_LEAVE_VALUE : 0) + (score.autoRobot2Leave ? AUTO_LEAVE_VALUE : 0);
    score.autoParkPoints = (score.autoRobot1Park ? AUTO_PARK_VALUE : 0) + (score.autoRobot2Park ? AUTO_PARK_VALUE : 0);
    score.autoHivePoints = AUTO_HIVE_TIP_VALUE * score.autoHiveTips;
    score.autoPoints = score.autoLeavePoints + score.autoParkPoints + score.autoHivePoints;

    score.teleopHivePoints = TELEOP_HIVE_TIP_VALUE * score.teleopHiveTips + TELEOP_HIVE_POLLEN_NECTAR_VALUE * score.teleopHivePollenNectar;
    score.teleopFlowerPoints = scoreFlower(score.redAllianceFlower, alliance) + scoreFlower(score.blueAllianceFlower, alliance) + scoreFlower(score.audienceFlower, alliance) + scoreFlower(score.scoringFlower, alliance);
    score.teleopGardenPoints = TELEOP_GARDEN_POLLEN_NECTAR_VALUE * score.teleopGardenPollenNectar;
    score.teleopParkPoints = (score.teleopRobot1Park ? TELEOP_PARK_VALUE : 0) + (score.teleopRobot2Park ? TELEOP_PARK_VALUE : 0);
    score.teleopPoints = score.teleopHivePoints + score.teleopFlowerPoints + score.teleopGardenPoints + score.teleopParkPoints;

    score.swarmRPProgress = [score.autoLeavePoints + score.autoParkPoints + score.teleopParkPoints, SWARM_RP_THRESHOLD];
    score.swarmRP = score.swarmRPProgress[0] >= score.swarmRPProgress[1];
    score.pollinator1RPProgress = [score.autoHiveTips + score.teleopHiveTips, POLLINATOR_1_RP_THRESHOLD];
    score.pollinator1RP = score.pollinator1RPProgress[0] >= score.pollinator1RPProgress[1];
    score.pollinator2RPProgress = [score.autoHiveTips + score.teleopHiveTips, POLLINATOR_2_RP_THRESHOLD];
    score.pollinator2RP = score.pollinator2RPProgress[0] >= score.pollinator2RPProgress[1];

    score.foulPointsCommitted = score.minorFouls * MINOR_FOUL_VALUE + score.majorFouls * MAJOR_FOUL_VALUE;

    score.preFoulTotal = score.autoPoints + score.teleopPoints;
}

function scoreFlower(flower: BiobuzzScoringElement[], alliance: AllianceColor) {
    const myNectar = alliance == AllianceColor.RED ? BiobuzzScoringElement.RED_NECTAR : BiobuzzScoringElement.BLUE_NECTAR;
    const owned = flower.filter(e => e != BiobuzzScoringElement.POLLEN).reduce((_, b) => b, BiobuzzScoringElement.POLLEN) == myNectar
    const earnsBonus = flower.filter(e => e != BiobuzzScoringElement.POLLEN)[0] == myNectar
    console.log(earnsBonus)
    return (owned ? TELEOP_FLOWER_POLLEN_NECTAR_VALUE * flower.length : 0) + (earnsBonus ? TELEOP_BOTTOM_NECTAR_BONUS_VALUE : 0);
}


